//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

export function getQuerySeparator(url: string) {
  return url.includes('?') ? '&' : '?';
}
